// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const perPageSize = 5;
//export const API_BASE_URL = "https://smartmoneyinc.ca/backend/";

// export const API_BASE_URL = 'http://localhost:8000/';
// export const API_BASE_URL = 'http://3.6.142.67/backend/';
export const API_BASE_URL = 'https://smartmoneywealth.ca/backend/';
export const GoogleReCaptchKEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

export const accountTypeArray = [
    { label: 'All In One', value: 1 },
    { label: 'DAP', value: 6 },
    { label: 'TFSA', value: 7 },
    { label: 'RRSP', value: 8 },
    // { label: 'TFSA', value: 0 },
    { label: 'SpRRSP', value: 9 },
    { label: 'LIRA', value: 10 },
    { label: 'RRIF', value: 11 },
    { label: 'LIF', value: 13 },
    { label: 'LRSP', value: 20 },
    { label: 'Corporate Margin', value: 21 },
    { label: 'Individual Single RESP', value: 22 },
    { label: 'Individual Family RESP', value: 23 },
    { label: 'Joint Single RESP', value: 24 },
    { label: 'Joint Family RESP', value: 25 },
    { label: 'Joint Non-Registered', value: 26 }
];

export const colorArray = [
    '#3CA4B1',
    '#54C4C6',
    '#9DFFFC',
    '#535353',
    '#818382',
    '#AAAAAA',
    '#C0C0C0',
    '#3CA4B1',
    '#54C4C6',
    '#73C9C6',
    '#535353',
    '#818382',
    '#AAAAAA',
    '#C0C0C0'
];


export const ageRangeArray = [
    { label: '18-24', value: 1 },
    { label: '25-34', value: 2 },
    { label: '35-44', value: 3 },
    { label: '45-54', value: 4 },
    { label: '55-64', value: 5 },
    { label: '65+', value: 6 }
]

export const provinceArray = [
    { label: 'Ontario', value: 1 },
    { label: 'Alberta', value: 2 },
    { label: 'Quebec', value: 3 },
    { label: 'British Columbia', value: 4 },
    { label: 'Saskatchewan', value: 5 }
];

export const getAgeRangeId = (age) => {
    if (age >= 18 && age <= 24) return 1;
    if (age >= 25 && age <= 34) return 2;
    if (age >= 35 && age <= 44) return 3;
    if (age >= 45 && age <= 54) return 4;
    if (age >= 55 && age <= 64) return 5;
    if (age >= 65) return 6;
    return null;
};

export const countryArray = [
    { label: 'Canada', value: 'CA' },
    { label: 'Other', value: 'OTH' }
];


export const gendersOptionArray = [
    { label: 'Male', value: 1 },
    { label: 'Female', value: 0 }
];


export const maritalStatus = [
    { label: 'Single', value: 1 },
    { label: 'Married', value: 2 },
    { label: 'Common Law', value: 3 },
    { label: 'Divorced', value: 4 },
    { label: 'Separated', value: 5 },
    { label: 'Widowed', value: 6 }
];

export const empStatus = [
    { label: 'Employed', value: 1 },
    { label: 'Self-Employed', value: 2 },
    { label: 'Retired', value: 3 },
    { label: 'Unemployed', value: 4 }
];

export const taxJurisdictionOption = [
    { label: 'I will apply or have applied for a TIN but have not yet received it', value: 1 },
    { label: 'My jurisdiction of tax residence does not issue TINs to its resident', value: 2 },
    { label: 'Other reason', value: 3 }
];

export const investOption = [
    { label: 'Other', value: 1 },
    { label: 'Investment', value: 0 }
];

export const objectOption = [
    { label: 'I / We DO NOT OBJECT', value: 1 },
    { label: 'I / We DO OBJECT', value: 2 }
];

export const objectDisclosureOption = [
    { label: 'I / We Object', value: 0 },
    { label: 'I / We Accept', value: 1 }
];

export const agreementOption = [
    {
        label: 'I / We DO OBJECT to the Broker delivering electronically to us the documents mentioned in Part 2.',
        value: 1
    },
    {
        label: 'I / We DO NOT OBJECT to the Broker delivering electronically to me/us the documents mentioned in Part 2 in respect with the following terms and conditions:',
        value: 2
    }
];

export const languageOption = [
    { label: 'English', value: 1 },
    { label: 'French', value: 2 }
];

export const nIOption = [
    {
        label: 'I / We WANT to receive ALL security holder materials sent to beneficial owners of securities.',
        value: 1
    },
    {
        label: 'I / We WANT to receive ONLY proxy-related materials that are sent in connection with a special meeting.',
        value: 2
    },
    {
        label: 'I / We DECLINE to receive ALL security holder materials sent to beneficial owners of securities. Even if I/we decline to receive these types of materials, I/we understand that a reporting issuer or other person or company may send these materials to us at its own expense.',
        value: 3
    }
];
export const employmentAddressOption = [
    { label: 'As Specified Below', value: 0 },
    { label: 'Same As Residential Address', value: 1 },
    { label: 'Same As Mailing Address', value: 2 }
];

export const employmentSAddressOption = [
    { label: 'As Specified Below', value: 0 },
    { label: 'Same As Residential Address', value: 1 }
];

export const radioOption = [
    { label: 'Yes', value: 1 },
    { label: 'No', value: 0 }
];

export const modificationOfInstrOption = [
    {
        label: 'I / We understand that these instructions may be changed at any time by giving written notice to the Broker and that will be made as soon as possible.',
        value: 1
    },
    {
        label: `I / We have read and understand the explanation that you have provided to me/us in connection with National Instrument 54-101, "Communication with Beneficial Owner of Securities of a Reporting Issuer". The choices I /we have indicated above apply to all of the securities held in my /our account(s).`,
        value: 2
    }
];

export const applicantSelectOption = [
    { label: 'Self', value: 1 },
    { label: 'Spouse Or Common Law', value: 2 },
    { label: 'Child', value: 3 },
    { label: 'Parent', value: 4 },
    { label: 'Sibling', value: 5 },
    { label: 'ParentInLaw', value: 6 }
];

export const checkboxOptions = [
    { label: 'Investments for the eventual payment of a child’s education', value: 1 },
    { label: 'Investments for personal savings, long term savings or retirement', value: 2 },
    { label: 'Investments of the retained earnings of a corporation', value: 3 },
    { label: 'Investments for a group plan', value: 4 },
    { label: 'Other', value: 5 }
];

export const investmentProfileOptions = [
    {
        label: 'What is your Annual Net Income (CAD)?',
        applicantName: 'applicantAnnualIncome',
        jointApplicantName: 'jointApplicantAnnualIncome',
        options: [{ "1": '<45,000' },
        { "2": '45,001 - 50,000' },
        { "3": '55,001 - 100,000' },
        { "5": '100,001 - 150,000' },
        { "6": '150,001 - 250,000' },
        { "7": '250,001 - 500,000' },
        { "8": '500,001 - 1,000,000' },
        { "9": '>1,000,000' }]
    },
    {
        label: 'What is your Liquid Net Worth (CAD)?',
        applicantName: 'applicantLiquidNetWorth',
        jointApplicantName: 'jointApplicantLiquidNetWorth',
        options: [
            { "1": '<45,000' },
            { "2": '45,001 - 50,000' },
            { "3": '55,001 - 100,000' },
            { "5": '100,001 - 150,000' },
            { "6": '150,001 - 250,000' },
            { "7": '250,001 - 500,000' },
            { "8": '500,001 - 1,000,000' },
            { "9": '>1,000,000' }]
    },
    {
        label: 'What is your Net Worth (CAD)?',
        applicantName: 'applicantNetWorth',
        jointApplicantName: 'jointApplicantNetWorth',
        options: [{ "1": '<45,000' },
        { "2": '45,001 - 50,000' },
        { "3": '55,001 - 100,000' },
        { "5": '100,001 - 150,000' },
        { "6": '150,001 - 250,000' },
        { "7": '250,001 - 500,000' },
        { "8": '500,001 - 1,000,000' },
        { "9": '>1,000,000' }]
    }
];

export const fundSources = [
    { label: 'Employment Income', value: 1 },
    { label: 'Inheritance', value: 2 },
    { label: 'Gift', value: 3 },
    { label: 'Investment Income', value: 4 },
    { label: 'Savings', value: 5 },
    { label: 'Payment for Legal Settlement', value: 6 },
    { label: 'Sale of an Asset', value: 7 },
    { label: 'Other', value: 8 }
];

export const relationshipToArray = [
    { label: 'Self', value: 1 },
    { label: 'Spouse Or Common Law', value: 2 },
    { label: 'Child', value: 3 },
    { label: 'Parent', value: 4 },
    { label: 'Sibling', value: 5 },
    { label: 'ParentInLaw', value: 6 },
];

export const beneficiaryDataArray = [
    { label: 'Not interested', value: 1 },
    { label: 'Interested', value: 2 },
    { label: 'Client has form', value: 3 },
    { label: 'Custodian confirm', value: 4 }
];

export const userProgressDataArray = [
    { label: 'Account Selection', value: 1 },
    { label: 'Account Question Selection', value: 2 },
    { label: 'CI Form', value: 3 },
    { label: 'SMI Agreement', value: 4 },
    { label: 'Completed', value: 5 },
    { label: 'Register', value: 6 }
];

export const getProgressColor = (progress) => {
    const colors = ['red', '#3CA4B1', 'blue', 'orange', '#979727', 'green'];
    return colors[progress] || 'gray';
};

export const getScoreColor = (score) => {
    if (score < 4) return "#EF4444";
    if (score < 6) return "#F97316";
    if (score < 8) return "#FACC15";
    return "#22C55E";
};

export const periodOptions = [
    { label: "Select...", value: "" },
    { label: "Last 3 Months", value: 3 },
    { label: "Last 6 Months", value: 6 },
    { label: "Last 12 Months", value: 12 },
];


